<template>
  <div class="checkbox-container">
    <label :class="{ 'left-label': leftLabel }">
      <input type="checkbox" :checked="modelValue" @change="handleChange">
      <span >{{ label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    leftLabel: {
      type: Boolean,
      default: false
    },
    modelValue: { // Use value prop for v-model
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleChange(event) {
      this.$emit('update:modelValue', event.target.checked) // Emit update event for v-model
    }
  }
}
</script>


<style scoped>
.checkbox-container {
  display: flex;
  align-items: center;
}

.left-label {
  flex-direction: row-reverse;
  justify-content: flex-end;
}

label {
  cursor: pointer;
  display: flex;
  align-items: center;
}

label span {
  margin: 0 8px;
  font-size: 17px;
}
</style>

